// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".center[data-v-29bec098]{text-align:center}.bottom[data-v-29bec098]{position:fixed;bottom:0;width:100%}.backColor[data-v-29bec098]{background-color:grey}", ""]);
// Exports
module.exports = exports;
